'use client';
/* eslint-disable @typescript-eslint/no-explicit-any */

// Notes panel below RecordingPlayer. Notes outlive recordings (per spec §7).

import { useEffect, useState } from 'react';
import { authFetch } from '@/lib/authFetch';

const API = process.env.NEXT_PUBLIC_API_URL || 'https://api.crewsyncautomation.io';

export default function RecordingNotes({ leadId, recordingId }: { leadId: string; recordingId: string }) {
  const [notes, setNotes] = useState<any[]>([]);
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;
    authFetch(`${API}/api/widget-lead-notes?lead_id=${leadId}`)
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (!cancelled && d?.data) setNotes(d.data); });
    return () => { cancelled = true; };
  }, [leadId]);

  async function save() {
    if (!draft.trim()) return;
    setSaving(true);
    try {
      const r = await authFetch(`${API}/api/widget-lead-notes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ lead_id: leadId, recording_id: recordingId, body: draft.trim() }),
      });
      if (r.ok) { const d = await r.json(); setNotes(n => [d.data, ...n]); setDraft(''); }
    } finally { setSaving(false); }
  }

  return (
    <div className="col-span-2 border-t border-[--border-subtle] pt-3 space-y-2">
      <div className="text-[11px] font-semibold text-[--text-primary]">Notes</div>
      {notes.map(n => (
        <div key={n.id} className="text-[11px] text-[--text-secondary] bg-[--bg-tint]/40 rounded px-2 py-1.5">
          <div className="text-[--text-primary] whitespace-pre-wrap">{n.body}</div>
          <div className="text-[10px] text-[--text-tertiary] mt-0.5">{new Date(n.created_at).toLocaleString()}</div>
        </div>
      ))}
      <div className="flex items-end gap-2">
        <textarea
          value={draft}
          onChange={e => setDraft(e.target.value)}
          rows={2}
          placeholder="Add a note about this session…"
          className="flex-1 px-2 py-1.5 text-[11px] rounded border border-[--border-subtle] bg-[--bg-card] text-[--text-primary] focus:outline-none focus:border-[#00C2A8]"
        />
        <button
          onClick={save} disabled={saving || !draft.trim()}
          className="px-3 py-1.5 text-[11px] rounded bg-[#00C2A8] text-white disabled:opacity-50"
        >Save</button>
      </div>
    </div>
  );
}
